import {ActionReducer, ActionReducerMap} from '@ngrx/store';
import * as fromFreelancer from '../reducers/freelancer.reducer';
import {combineReducers} from '@ngrx/store';

export interface FreelancerState {
  freelancers: fromFreelancer.FreelancerState;
}

export const reducers: ActionReducerMap<FreelancerState> = {
    freelancers: fromFreelancer.reducer,
};

export const reducer: ActionReducer<FreelancerState> = combineReducers(reducers);




// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/reducers/index.ts